import { useMemo } from 'react';
// @mui
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { formatDate, DateFormat } from 'src/compass/shared/util/casMoment';

type ICasCreateAndModifyDetails = {
  selectedAsOf: any;
};

export default function CasCreateAndModifyDetails({ selectedAsOf }: ICasCreateAndModifyDetails) {
  const hideDateModified = useMemo(
    () =>
      selectedAsOf?.dateCreated === selectedAsOf?.dateModified &&
      selectedAsOf?.userCreatedName === selectedAsOf?.userModifiedName,
    [selectedAsOf]
  );

  return (
    <Stack alignItems="flex-end">
      <Typography
        variant="caption"
        sx={{
          fontStyle: 'italic',
          color: 'text.disabled',
        }}
      >
        Created: {formatDate(selectedAsOf?.dateCreated, DateFormat.MDY)} by
        {` ${selectedAsOf?.userCreatedName}`}
      </Typography>

      {!hideDateModified && (
        <Typography
          variant="caption"
          sx={{
            fontStyle: 'italic',
            color: 'text.disabled',
          }}
        >
          Last Modified: {formatDate(selectedAsOf?.dateModified, DateFormat.MDY)} by
          {` ${selectedAsOf?.userModifiedName}`}
        </Typography>
      )}
    </Stack>
  );
}
